__turbopack_context__.v({
  "adult": "PEGI-module___M9Npa__adult",
  "child": "PEGI-module___M9Npa__child",
  "medium": "PEGI-module___M9Npa__medium",
  "pegi": "PEGI-module___M9Npa__pegi",
  "small": "PEGI-module___M9Npa__small",
  "teen": "PEGI-module___M9Npa__teen",
});
